module.exports = __webpack_public_path__ + "media/images/niq-help-5cfcc5ace05b959cab2f5d1c24fe56e2.svg";